/* Muralis — page behaviours (product forms, qty steppers, gallery,
   cart, address country/province selectors). No dependencies. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  /* ---------- Quantity steppers ---------- */
  function setupQtySteppers(root) {
    (root || document).querySelectorAll('[data-p4s-qty]').forEach(function (wrap) {
      if (wrap.dataset.p4sQtyReady) return;
      wrap.dataset.p4sQtyReady = 'true';
      var input = wrap.querySelector('input[type="number"]');
      if (!input) return;
      wrap.querySelectorAll('button[data-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.dataset.step, 10) || 0;
          var min = parseInt(input.min, 10);
          if (isNaN(min)) min = 0;
          var next = (parseInt(input.value, 10) || min) + step;
          if (next < min) next = min;
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Product form: split option selectors, variant matching ----------
     Reads the split product-option radios, matches the selected combination to a
     variant from the embedded JSON, keeps the hidden name="id" input in sync, and
     updates price / availability. Falls back to id lookup for single-variant
     products. Dispatches p4s:variant-change so later features (e.g. gallery image
     switching) can react without re-querying the DOM. */
  function setupProductForms() {
    document.querySelectorAll('[data-p4s-product]').forEach(function (scope) {
      if (scope.dataset.p4sFormReady) return;
      scope.dataset.p4sFormReady = 'true';
      var dataEl = scope.querySelector('script[data-p4s-variants]');
      var idInput = scope.querySelector('[data-p4s-variant-id]');
      if (!dataEl || !idInput) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      if (!variants || !variants.length) return;

      var optionInputs = Array.prototype.slice.call(
        scope.querySelectorAll('[data-p4s-option-input]')
      );
      var fieldsets = Array.prototype.slice.call(
        scope.querySelectorAll('[data-p4s-option-index]')
      );

      var priceEl = scope.querySelector('[data-p4s-price]');
      var compareEl = scope.querySelector('[data-p4s-compare]');
      var saleBadge = scope.querySelector('[data-p4s-sale-badge]');
      var unitEl = scope.querySelector('[data-p4s-unit-price]');
      var button = scope.querySelector('[data-p4s-add]');
      var paymentTermsInputs = Array.prototype.slice.call(
        scope.querySelectorAll('[data-p4s-payment-terms-variant-id]')
      );

      /* Keep the Shop Pay Installments form's hidden variant id in sync so its
         banner re-renders for the selected variant. That form lives outside the
         main add-to-cart form (next to the price), so it needs its own sync. */
      function syncPaymentTermsVariant(variant) {
        if (!variant || !variant.id) return;
        paymentTermsInputs.forEach(function (input) {
          if (String(input.value) !== String(variant.id)) {
            input.value = variant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      function variantById(id) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === id) return variants[i];
        }
        return null;
      }

      function selectedValues() {
        var values = [];
        optionInputs.forEach(function (input) {
          if (!input.checked) return;
          var idx = parseInt(input.getAttribute('data-option-index'), 10);
          if (!isNaN(idx)) values[idx] = input.getAttribute('data-option-value');
        });
        return values;
      }

      function variantForValues(values) {
        for (var i = 0; i < variants.length; i++) {
          var opts = variants[i].options || [];
          if (opts.length !== values.length) continue;
          var match = true;
          for (var j = 0; j < values.length; j++) {
            if (opts[j] !== values[j]) { match = false; break; }
          }
          if (match) return variants[i];
        }
        return null;
      }

      /* Is there an available variant whose option[idx] === val that also agrees
         with every other currently-selected option value? */
      function valueAvailable(idx, val, values) {
        for (var i = 0; i < variants.length; i++) {
          var opts = variants[i].options || [];
          if (opts[idx] !== val || !variants[i].available) continue;
          var ok = true;
          for (var k = 0; k < values.length; k++) {
            if (k === idx) continue;
            if (values[k] != null && opts[k] !== values[k]) { ok = false; break; }
          }
          if (ok) return true;
        }
        return false;
      }

      function paintOptions(values) {
        optionInputs.forEach(function (input) {
          var label = input.closest('.p4s-option-value') || input.parentNode;
          if (!label) return;
          if (input.checked) label.classList.add('is-selected');
          else label.classList.remove('is-selected');

          var idx = parseInt(input.getAttribute('data-option-index'), 10);
          if (isNaN(idx)) return;
          var val = input.getAttribute('data-option-value');
          if (valueAvailable(idx, val, values)) {
            label.classList.remove('is-disabled');
            input.removeAttribute('aria-disabled');
          } else {
            label.classList.add('is-disabled');
            input.setAttribute('aria-disabled', 'true');
          }
        });

        fieldsets.forEach(function (fs) {
          var idx = parseInt(fs.getAttribute('data-p4s-option-index'), 10);
          var span = fs.querySelector('[data-p4s-selected-option-value]');
          if (span && !isNaN(idx) && values[idx] != null) span.textContent = values[idx];
        });
      }

      function update() {
        var variant;
        if (optionInputs.length) {
          var values = selectedValues();
          variant = variantForValues(values);
          if (variant) idInput.value = variant.id;
          paintOptions(values);
        } else {
          variant = variantById(parseInt(idInput.value, 10));
        }

        if (variant) {
          if (priceEl) priceEl.textContent = variant.price;
          if (compareEl) {
            if (variant.compare) {
              compareEl.textContent = variant.compare;
              compareEl.hidden = false;
            } else {
              compareEl.textContent = '';
              compareEl.hidden = true;
            }
          }
          if (saleBadge) saleBadge.hidden = !variant.compare;
          if (unitEl) {
            if (variant.unit) {
              unitEl.textContent = variant.unit;
              unitEl.hidden = false;
            } else {
              unitEl.textContent = '';
              unitEl.hidden = true;
            }
          }
          syncPaymentTermsVariant(variant);
        }

        if (button) {
          var sellable = !!(variant && variant.available);
          button.disabled = !sellable;
          var label = sellable ? button.dataset.labelAdd : button.dataset.labelSoldout;
          if (label) button.textContent = label;
        }

        scope.dispatchEvent(new CustomEvent('p4s:variant-change', {
          bubbles: true,
          detail: { variant: variant || null }
        }));
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', update);
      });
      update();
    });
  }

  /* ---------- Product gallery: rich media (image / 3D / video / external video) ----------
     Every media item is rendered into the stage; only the active one is shown.
     Clicking a thumbnail shows that media; selecting a variant whose featured media
     differs also shows it, via the p4s:variant-change event dispatched by
     setupProductForms(). Hidden videos are paused. Safe to re-run (dataset guard). */
  function setupGalleries() {
    document.querySelectorAll('[data-p4s-gallery]').forEach(function (gallery) {
      if (gallery.dataset.p4sGalleryReady) return;
      gallery.dataset.p4sGalleryReady = 'true';

      var mediaItems = Array.prototype.slice.call(gallery.querySelectorAll('[data-p4s-media]'));
      if (!mediaItems.length) return;

      function showMedia(mediaId) {
        if (mediaId == null || mediaId === '') return;
        var found = false;
        mediaItems.forEach(function (item) {
          if (String(item.getAttribute('data-media-id')) === String(mediaId)) found = true;
        });
        if (!found) return; // selected media not in this gallery — leave current view

        mediaItems.forEach(function (item) {
          var match = String(item.getAttribute('data-media-id')) === String(mediaId);
          item.hidden = !match;
          if (!match) {
            var vid = item.querySelector('video');
            if (vid && typeof vid.pause === 'function') vid.pause();
          }
        });

        gallery.querySelectorAll('[data-p4s-thumb].is-active').forEach(function (button) {
          button.classList.remove('is-active');
        });
        var activeThumb = gallery.querySelector('[data-p4s-thumb][data-media-id="' + mediaId + '"]');
        if (activeThumb) activeThumb.classList.add('is-active');
      }

      gallery.querySelectorAll('[data-p4s-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          showMedia(thumb.getAttribute('data-media-id'));
        });
      });

      /* Variant media switching: event dispatched from the enclosing product section.
         If the selected variant has no associated media, leave the current view. */
      var productScope = gallery.closest('[data-p4s-product]');
      if (productScope) {
        productScope.addEventListener('p4s:variant-change', function (event) {
          var variant = event.detail && event.detail.variant;
          if (!variant || variant.featured_media_id == null) return;
          showMedia(variant.featured_media_id);
        });
      }
    });
  }

  /* ---------- Product pickup availability (Section Rendering API) ----------
     Fetches sections/pickup-availability.liquid for the selected variant and
     injects it; refreshes on p4s:variant-change; wires the locations modal.
     The p4sPickupReady guard makes it safe to re-run on section reload. */
  function setupPickupAvailability() {
    document.querySelectorAll('[data-p4s-pickup-availability]').forEach(function (container) {
      if (container.dataset.p4sPickupReady) return;
      container.dataset.p4sPickupReady = 'true';

      var scope = container.closest('[data-p4s-product]');
      var lastOpener = null;

      function getRouteRoot() {
        var root = '/';
        if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
          root = window.Shopify.routes.root;
        } else if (container.dataset.rootUrl) {
          root = container.dataset.rootUrl;
        }
        if (root.charAt(root.length - 1) !== '/') root += '/';
        return root;
      }

      function pickupUrl(variantId) {
        return getRouteRoot() + 'variants/' + encodeURIComponent(variantId) +
               '/?section_id=pickup-availability';
      }

      function hide() {
        container.innerHTML = '';
        container.hidden = true;
        container.classList.remove('is-loading');
        /* Invalidate any in-flight fetch so its late response is treated as stale
           and cannot re-show the container, and never orphan the body scroll lock. */
        container.dataset.pendingVariant = '';
        document.body.classList.remove('p4s-pickup-open');
      }

      function fillModalMeta() {
        var titleEl = container.querySelector('[data-p4s-pickup-product-title]');
        if (titleEl && container.dataset.productTitle) {
          titleEl.textContent = container.dataset.productTitle;
        }
        var variantTitleEl = container.querySelector('[data-p4s-pickup-variant-title]');
        if (variantTitleEl) {
          var isDefault = container.dataset.hasOnlyDefaultVariant === 'true' ||
                          (variantTitleEl.textContent || '').trim() === 'Default Title';
          if (isDefault) variantTitleEl.hidden = true;
        }
      }

      function fetchPickup(variantId) {
        if (!variantId || typeof window.fetch !== 'function') { hide(); return; }
        container.dataset.pendingVariant = String(variantId);
        container.classList.add('is-loading');
        window.fetch(pickupUrl(variantId))
          .then(function (response) {
            if (!response.ok) throw new Error('Pickup request failed');
            return response.text();
          })
          .then(function (text) {
            if (container.dataset.pendingVariant !== String(variantId)) return; // stale response
            container.classList.remove('is-loading');
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var content = doc.querySelector('[data-p4s-pickup-content]');
            if (content) {
              /* Re-injection destroys any open modal node, so drop its scroll lock. */
              document.body.classList.remove('p4s-pickup-open');
              container.innerHTML = content.outerHTML;
              container.hidden = false;
              fillModalMeta();
            } else {
              hide();
            }
          })
          .catch(function () {
            if (container.dataset.pendingVariant !== String(variantId)) return;
            hide();
          });
      }

      function closeModal(modal) {
        if (!modal) return;
        modal.hidden = true;
        document.body.classList.remove('p4s-pickup-open');
        if (lastOpener && typeof lastOpener.focus === 'function' && document.contains(lastOpener)) {
          lastOpener.focus();
        }
      }

      /* Modal: event delegation so it keeps working after each re-injection. */
      container.addEventListener('click', function (event) {
        var openBtn = event.target.closest('[data-p4s-pickup-modal-open]');
        if (openBtn) {
          var modalId = openBtn.getAttribute('aria-controls');
          var modal = (modalId && document.getElementById(modalId)) ||
                      container.querySelector('[data-p4s-pickup-modal]');
          if (modal) {
            lastOpener = openBtn;
            modal.hidden = false;
            document.body.classList.add('p4s-pickup-open');
            var closeBtn = modal.querySelector('[data-p4s-pickup-modal-close]');
            (closeBtn || modal).focus();
          }
          return;
        }
        var closeBtn = event.target.closest('[data-p4s-pickup-modal-close]');
        if (closeBtn) {
          closeModal(closeBtn.closest('[data-p4s-pickup-modal]'));
          return;
        }
        if (event.target.matches('[data-p4s-pickup-modal]')) {
          closeModal(event.target);
        }
      });

      container.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          var openModal = container.querySelector('[data-p4s-pickup-modal]:not([hidden])');
          if (openModal) closeModal(openModal);
        }
      });

      /* Initial load for the server-rendered variant. Independent of the initial
         p4s:variant-change (which may fire before this listener is attached). */
      fetchPickup(container.dataset.variantId);

      if (scope) {
        scope.addEventListener('p4s:variant-change', function (event) {
          var variant = event.detail && event.detail.variant;
          if (!variant || !variant.available) { hide(); return; }
          fetchPickup(variant.id);
        });
      }
    });
  }

  /* ---------- Product recommendations: fetch from Shopify endpoint ---------- */
  function setupRecommendations() {
    document.querySelectorAll('[data-p4s-recommendations]').forEach(function (container) {
      if (container.dataset.p4sRecsReady) return;
      container.dataset.p4sRecsReady = 'true';
      var url = container.dataset.url;
      if (!url || typeof window.fetch !== 'function') return;
      window.fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('Recommendations request failed');
          return response.text();
        })
        .then(function (text) {
          var temp = document.createElement('div');
          temp.innerHTML = text;
          var inner = temp.querySelector('[data-p4s-recommendations]');
          if (inner && inner.innerHTML.trim().length) {
            container.innerHTML = inner.innerHTML;
          }
        }, function () {
          /* Request failed — leave the container empty */
        });
    });
  }

  /* ---------- Cart: the box is edited freely; ONLY "Update cart" applies it ----------
     2.9.25. Before this, pressing +/- fired a `change` event and the listener here called
     form.submit(), so the cart applied the moment he touched a stepper. He rejected exactly
     that behaviour on photo4sure ("Update Cart should only work when then I click the this
     button!") and asked for the same here.

     RULES - do not "improve" any of these back:
       - `+` / `-` and typing edit THE NUMBER IN THE BOX ONLY. No request, no re-render.
       - Until Update cart is pressed the line totals and subtotal deliberately still show
         the OLD figures. That is the point of having an Update button; it is not a bug.
       - Exactly two things send a request: clicking Update cart, and Enter inside the
         quantity box (intercepted, because Enter would otherwise natively submit).
       - NO setTimeout, NO debounce, NO 'change' listener in this function.

     WHY AJAX AND NOT THE PLAIN FORM POST: he reviews in the Shopify theme editor, whose
     preview iframe silently blocks form submissions. A native submit here looks like a dead
     button to him. fetch() is not blocked. The button still keeps type="submit" name="update"
     so with JS off, or if the fetch throws, the original POST still happens.

     SECURE CHECKOUT IS DELIBERATELY NOT INTERCEPTED - it must stay a real navigation. */
  function setupCart() {
    /* Class, not a data-* attribute: Liquid's {% form %} tag cannot emit a hyphenated
       attribute name, and trying made the cart page fail to render at all.
       See the comment in sections/main-cart.liquid. */
    var form = document.querySelector('form.p4s-cart-form');
    if (!form) return;
    if (form.dataset.p4sCartReady) return;
    form.dataset.p4sCartReady = 'true';

    var root = document.querySelector('section.p4s-cart');
    var busy = false;

    /* line order in the DOM is the line order /cart/update.js expects */
    function quantities() {
      var out = [];
      form.querySelectorAll('[data-p4s-qty] input').forEach(function (input) {
        var n = parseInt(input.value, 10);
        out.push(isNaN(n) || n < 0 ? 0 : n);
      });
      return out;
    }

    /* prototype call, so a field named "submit" cannot shadow the method */
    function nativeSubmit() {
      HTMLFormElement.prototype.submit.call(form);
    }

    /* Re-render from freshly fetched cart HTML. Two fallbacks: if the section cannot be
       found in the response we hard-reload. A silent no-op here would leave the OLD prices
       on screen after a successful server update - which looks exactly like the broken
       button we are fixing. */
    function rerender() {
      return fetch(window.location.pathname, { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('section.p4s-cart');
          if (!fresh || !root) { window.location.reload(); return; }
          root.innerHTML = fresh.innerHTML;
          setupQtySteppers(root);
          setupCart();
        });
    }

    function applyUpdate() {
      if (busy) return;
      busy = true;
      if (root) root.classList.add('is-cart-busy');
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        /* `note` is deliberately NOT sent. Absent means "leave it alone"; sending note:""
           would wipe a note the customer already has. */
        body: JSON.stringify({ updates: quantities() })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart update failed');
          return r.json();
        })
        .then(function () { return rerender(); })
        .then(function () {
          busy = false;
          if (root) root.classList.remove('is-cart-busy');
        })
        .catch(function () {
          busy = false;
          if (root) root.classList.remove('is-cart-busy');
          nativeSubmit();
        });
    }

    var updateBtn = form.querySelector('[data-p4s-cart-update]');
    if (updateBtn) {
      updateBtn.addEventListener('click', function (e) {
        e.preventDefault();
        applyUpdate();
      });
    }

    /* Enter inside the number box would natively submit the form (full reload, and blocked
       in the theme editor). Route it through the same path as the button. */
    form.querySelectorAll('[data-p4s-qty] input').forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();
          applyUpdate();
        }
      });
    });
  }

  /* ---------- Address forms: country / province selects ---------- */
  function setupCountrySelectors() {
    document.querySelectorAll('[data-p4s-country]').forEach(function (countrySelect) {
      var wrapper = countrySelect.closest('form') || document;
      var provinceSelect = wrapper.querySelector('[data-p4s-province="' + countrySelect.dataset.p4sCountry + '"]');
      if (!provinceSelect) return;
      var provinceWrap = provinceSelect.closest('[data-p4s-province-wrap]') || provinceSelect;

      function updateProvinces() {
        var option = countrySelect.options[countrySelect.selectedIndex];
        var raw = option ? option.getAttribute('data-provinces') : null;
        var provinces = [];
        try {
          provinces = raw ? JSON.parse(raw) : [];
        } catch (e) {
          provinces = [];
        }
        provinceSelect.innerHTML = '';
        if (!provinces.length) {
          provinceWrap.hidden = true;
          return;
        }
        provinces.forEach(function (p) {
          var opt = document.createElement('option');
          opt.value = p[0];
          opt.textContent = p[1];
          if (provinceSelect.dataset['default'] === p[0]) opt.selected = true;
          provinceSelect.appendChild(opt);
        });
        provinceWrap.hidden = false;
      }

      if (countrySelect.dataset['default']) {
        for (var i = 0; i < countrySelect.options.length; i++) {
          if (countrySelect.options[i].value === countrySelect.dataset['default']) {
            countrySelect.selectedIndex = i;
            break;
          }
        }
      }
      countrySelect.addEventListener('change', updateProvinces);
      updateProvinces();
    });
  }

  /* ---------- Address: toggle add / edit forms ---------- */
  function setupAddressToggles() {
    document.querySelectorAll('[data-p4s-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.dataset.p4sToggle);
        if (!target) return;
        target.hidden = !target.hidden;
        if (!target.hidden) {
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  }

  /* ---------- Gift card recipient form ----------
     Shows recipient email/name/message/send-on fields when the buyer ticks
     "send to someone else". Fields are disabled while hidden so a normal gift
     card purchase still works, and email becomes required only when sending.
     Sets __shopify_offset to the browser timezone offset on enable. */
  function setupGiftCardRecipientForms() {
    document.querySelectorAll('[data-p4s-gift-recipient]').forEach(function (root) {
      if (root.dataset.p4sGiftReady) return;
      root.dataset.p4sGiftReady = 'true';

      var toggle = root.querySelector('[data-p4s-gift-recipient-toggle]');
      if (!toggle) return;
      var fields = root.querySelector('[data-p4s-gift-recipient-fields]');
      var fieldEls = Array.prototype.slice.call(
        root.querySelectorAll('[data-p4s-gift-recipient-field]')
      );
      var email = root.querySelector('[data-p4s-gift-recipient-email]');
      var offset = root.querySelector('[data-p4s-gift-recipient-offset]');

      function apply() {
        var on = toggle.checked;
        if (fields) fields.hidden = !on;
        fieldEls.forEach(function (el) { el.disabled = !on; });
        if (email) {
          if (on) email.setAttribute('required', 'required');
          else email.removeAttribute('required');
        }
        if (offset && on) offset.value = new Date().getTimezoneOffset();
      }

      toggle.addEventListener('change', apply);
      apply(); /* Honour the server-rendered open state (submitted values / errors). */
    });
  }

  ready(function () {
    setupQtySteppers();
    setupProductForms();
    setupGalleries();
    setupPickupAvailability();
    setupGiftCardRecipientForms();
    setupRecommendations();
    setupCart();
    setupCountrySelectors();
    setupAddressToggles();
  });

  /* Theme editor: re-init when a section is re-rendered. Safe to re-run — every
     setup uses a dataset guard (p4sRecsReady / p4sGalleryReady / p4sQtyReady /
     p4sFormReady) so already-initialised elements are skipped and only the
     freshly re-rendered section is (re)bound. setupProductForms is included so
     variant -> gallery-image switching keeps working after an editor reload. */
  document.addEventListener('shopify:section:load', function () {
    setupRecommendations();
    setupQtySteppers();
    setupProductForms();
    setupGalleries();
    setupPickupAvailability();
    setupGiftCardRecipientForms();
  });
})();
